import { useSessionStorage, type RemovableRef } from '@vueuse/core';

export function useImpersonateToken(): RemovableRef<string> {
  return useSessionStorage('impersonateToken', '');
}
